import React, { useState } from "react";
import { API_BASE_URL } from "../../api/client";

// Inline SVG so the fallback never triggers another network request that
// could itself fail.
const FALLBACK =
  "data:image/svg+xml;charset=UTF-8," +
  encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 300" role="img" aria-hidden="true">
       <rect width="400" height="300" fill="#e8e4dc"/>
       <path d="M0 230 L120 150 L200 210 L290 140 L400 220 L400 300 L0 300 Z" fill="#cfc8bb"/>
       <circle cx="310" cy="80" r="34" fill="#cfc8bb"/>
     </svg>`
  );

/**
 * Renders an image stored in the backend uploads directory.
 *
 * A missing file previously showed the browser's broken-image icon; this
 * swaps in a neutral placeholder instead, and the failed flag stops it
 * retrying in a loop.
 */
export default function UploadImage({ file, alt = "", className, style, ...rest }) {
  const [failed, setFailed] = useState(false);

  const src = !file || failed ? FALLBACK : `${API_BASE_URL}/uploads/${file}`;

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      style={style}
      loading="lazy"
      onError={() => setFailed(true)}
      {...rest}
    />
  );
}
